import { useEffect, useState } from 'react';

export default function useSentimentSelect({ filter, changeFilter }: any) {
  const [sentimentSelect, setSentimentSelect] = useState<
    1 | 3 | 5 | null | undefined
  >(undefined);
  useEffect(() => {
    if (filter && sentimentSelect !== undefined) {
      let value = sentimentSelect === null ? [1, 3, 5] : [sentimentSelect];
      changeFilter({ ...filter, sentiment: value });
    }
  }, [sentimentSelect]);

  return {
    sentimentSelect,
    setSentimentSelect,
  };
}
